import commonModel from '../model/common'

class OssConfig {
  constructor () {
    this.configData = {
    }
    this.initConfigData()
  }

  async initConfigData () {
    try {
      const { datas} = await commonModel.getOssConfig({})
      this.configData = datas
    } catch (error) {
      console.error('Failed to fetch data:', error)
    }
  }
  // public getConfigData(): IConfigData {
  //   return this.configData;
  // }
}
const ossConfig = new OssConfig()
// 导出获取的配置URL相关内容
export default ossConfig 
